module.exports = __webpack_public_path__ + "img/jc-gellidon-1386352-unsplash.89cf1b9d.jpg";